module.exports = __webpack_public_path__ + "static/team-2-4-397a7226db76fd0869d41a44d3c49b8a.jpg";